export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';
export const AUTHENTICATED = 'AUTHENTICATED';
export const LOADING = 'LOADING';
